import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {getAntalVunnenByAfid,setofUpdatedashboard} from 'actions'
import { isEmpty } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboard} = accountsData;
      const { AvslutaAffarList,DashboardProspektFilterOption} = DashBoard;
      return {
          authUser,AvslutaAffarList,DashboardProspektFilterOption,
          updatedashboard
      };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
        getAntalVunnenByAfid: (Afid,userid,FilterOption) => dispatch(getAntalVunnenByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboard: () => dispatch(setofUpdatedashboard()),
        dispatch
    }
  }
  const useStyles = theme => ({

    root: {
        '&::-webkit-scrollbar': {
            width: '5px'
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#12484B',
            outline: '1px solid transparent'
          }
     },
    });
  class ClosedDeals extends Component {
    state={
        AvslutaAffarList:[],
        DashboardProspektFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getAntalVunnenByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })
       
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({ done:false })
                    const Afid = this.props.Afid;
                    this.props.getAntalVunnenByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            180000
        );
      }
    componentWillUnmount() {
      clearInterval(this.intervalID);
      this.intervalID = null
    }  
    formatNumber=(number)=>{
        console.log(number)
        if(number > 1000000){
            return `${(number/1000).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
    }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid;
        if(parseInt(this.props.updatedashboard) === 1){
            this.props.getAntalVunnenByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             })
             this.props.setofUpdatedashboard()
        }
        if(this.props.DashboardProspektFilterOption !== this.state.DashboardProspektFilterOption && !isEmpty(this.props.DashboardProspektFilterOption))
        {
             
            
            this.props.getAntalVunnenByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
            this.setState({
                DashboardProspektFilterOption:this.props.DashboardProspektFilterOption 
            }) 
        }
    }
    render() {
        const { classes } = this.props;
        return (
            <>
            <div className="d-flex justify-content-center">
            {
                     this.state.done === false?
                     <div style={{display: "flex",flexFlow: "column",width: "95%",height: this.props.height > 1 ? this.props.height : 200 ,marginBottom: '0.8rem'}}>
                     <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
                     <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
                     <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
                     <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
                     </div>
                     :
            <div className={classes.root} style={{ width: '90%', height: this.props.height > 1 ? this.props.height : 200 , overflowY: "auto", marginBottom: '0.8rem', border: 'none' }}>
            <Table>
                <TableBody>
                    {
                    isEmpty(this.props.AvslutaAffarList)?"":
                    this.props.AvslutaAffarList.map(object => {
                        return (
                            <TableRow key={object.id}>
                                <TableCell align="left" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:16, borderBottom: '1px solid #44D1C2' }}>
                                {`${object.FirstName} ${isEmpty(object.LastName)?"":object.LastName}`}    
                                </TableCell>
                                <TableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:16, borderBottom: '1px solid #44D1C2' }}>
                                {this.formatNumber(parseInt(object.total))}
                                </TableCell>
                            </TableRow>
                        );
                    })}

                </TableBody>
            </Table>


           
        </div>
    }
        </div>
        {
            isEmpty(this.props.AvslutaAffarList)?"":
       
                <div style={{marginLeft:'1rem',position: "relative",bottom:"0px"}}>
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '75px' }}>
                    {
                             this.state.done === false?
                             <Skeleton variant="rectangular"  height={ '100%'} width={'100%'} style={{margin:'auto 10px',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                             :
                        <p style={{ fontSize: this.props.fontSize2 > 1 ? this.props.fontSize2 : 90, marginBottom: '0', fontWeight:"500", color: '#44D1C2', '-webkit-text-stroke': '2px #54F3E3' }}>{
                        this.formatNumber(parseInt(this.props.AvslutaAffarList[0].total))
                        }</p>
                    }
                    </div>
                    <div style={{ marginTop: '0.5rem' }}>
                    {
                             this.state.done === false?
                             <Skeleton variant="rectangular"  height={ 30} style={{margin:'auto 10px',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                             :
                        <p className="text-center" style={{ fontSize: this.props.fontSize > 1 ? this.props.fontSize : 20 }}><IntlMessages id="DashBoard.Most.Deals"/> {`${this.props.AvslutaAffarList[0].FirstName} ${isEmpty(this.props.AvslutaAffarList[0].LastName)?"":this.props.AvslutaAffarList[0].LastName}`}</p>
                    }
                    </div>
                </div>
                 }
        </>
        )
    }
  }
  export default connect(
    mapStateToProps,mapDispatchToProps
  )(withStyles(useStyles)(ClosedDeals));


